import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-add-new-order',
  templateUrl: './dialog-add-new-order.component.html',
  styleUrls: ['./dialog-add-new-order.component.css']
})
export class DialogAddNewOrderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
